import * as React from 'react';
import { DocumentationPage } from './DocumentationPage';

export const CustomerDocumentation: React.FC = () => (
    <DocumentationPage title='Customer Documentation' articleType='customer'></DocumentationPage>  
);